<div class="wizard-inner-container">
  <div class="wizard-registration-title">{{'onboarding.titles.setup_shop_profile' | translate}}</div>
  <div class="wizard-form">

    <div *ngIf="loading" class="wizard-loading">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                         animationDuration=".5s">
      </p-progressSpinner>
      <div>{{ 'onboarding.messages.verifying_account' | translate}}</div>
    </div>

    <form [formGroup]="ShopProfileForm" (ngSubmit)="saveProfile()" *ngIf="!loading && !message">

      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input" type="text" formControlName="PhysicalAddress" placeholder="{{ 'onboarding.physical_address' | translate}}"/>
<!--            <label>{{ 'onboarding.physical_address' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input" type="text" formControlName="WebAddress" placeholder="{{ 'onboarding.web_address' | translate}}"/>
<!--            <label>{{ 'onboarding.web_address' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input" type="email" formControlName="Email" placeholder="{{ 'onboarding.shop_email' | translate}}"/>
<!--            <label>{{ 'onboarding.shop_email' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input" type="telephone" formControlName="PhoneNumber1" placeholder="{{ 'onboarding.shop_phonenumber' | translate}}"/>
<!--            <label>{{ 'onboarding.shop_phonenumber' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row margin-top-32 help-row">
        <div class="col-md-12">
          <div class="input-group">
            <input class="sign-up-input" type="number" formControlName="MinimumJobcardNo" placeholder="{{ 'onboarding.minimum_job_card_no' | translate}}"/>
<!--            <label>{{ 'onboarding.minimum_job_card_no' | translate}}</label>-->
          </div>
        </div>
        <span class="help fa hubtiger-tooltip tooltip-info" pTooltip="{{
          'onboarding.minimum_job_card_no_info' | translate
        }}"></span>
      </div>
      <div class="row margin-top-32 help-row" *ngIf="!onlyRentals">
        <div class="col-md-1">
          <div class="p-inputgroup">
            <p-inputSwitch binary="true" formControlName="OffersBookingService"></p-inputSwitch>
          </div>
        </div>
        <div class="col-md-11 label text-light"> <span class="ml-2">{{ 'onboarding.offer_online_bookings' | translate}}</span> </div>
        <span class="help fa hubtiger-tooltip tooltip-info-checkbox " pTooltip="{{
          'onboarding.offer_online_bookings_info' | translate
        }}"></span>
      </div>

      <div class="row margin-top-32 help-row">
        <div class="col-md-12 label text-light "
             [ngClass]="{'red': POSSystemID === -1}">{{ 'onboarding.select_pos' | translate}}:
        </div>
        <span class="help fa hubtiger-tooltip tooltip-info-text" pTooltip="{{
          'onboarding.select_pos_info' | translate
        }}"></span>
      </div>
      <div class="row margin-top-16">
        <div class="col-md-12">
          <div class="pos-systems">
            <div *ngFor="let system of POSSytems">
              <div class="logo" [ngClass]="{'active': system.POSID===POSSystemID}"
                   [ngStyle]="{'background-image': 'url('+system.Image+')'}"
                   (click)="setPOSSystemID(system.POSID === POSSystemID ? 0 : system.POSID)"></div>
            </div>
            <div>
              <div class="text" [ngClass]="{'active': POSSystemID === -2}" (click)="setPOSSystemID(-2)">
                <div>Other</div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">
          <button type="submit" class=" mt-1 iso-round-button iso-secondary w-100"
                  [disabled]="!ShopProfileForm.valid || saving">{{saving ? ('onboarding.button.please_wait' | translate) : ('onboarding.button.next' | translate)}}</button>
        </div>
      </div>
    </form>
    <div class="wizard-message fail margin-top-32" *ngIf="message">
      <div [innerHTML]="message"></div>
    </div>
  </div>
</div>
